export default __webpack_public_path__ + "static/harmonious-carousel-mobile-panel3-f9721e5792e524b16d9880c8db72a99ade39ea2d43c84b4f568374b4f3f4195b.png";